import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import LabResults from 'components/reports/LabResults'

export default function CardiovascularDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Cardiovascular Risks Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please give the following information:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.results.referToAttachments}>
                        <br />
                        <Question>Total Cholesterol results:</Question>
                        <LabResults
                            unknown={questions.results.subQuestions.totalCholesterol.unknown}
                            results={questions.results.subQuestions.totalCholesterol.results}
                        />
                        <br />
                        <Question>Triglycerides results:</Question>
                        <LabResults
                            unknown={questions.results.subQuestions.triglycerides.unknown}
                            results={questions.results.subQuestions.triglycerides.results}
                        />
                        <br />
                        <Question>HDL results:</Question>
                        <LabResults
                            unknown={questions.results.subQuestions.hdl.unknown}
                            results={questions.results.subQuestions.hdl.results}
                        />
                        <br />
                        <Question>LDL results:</Question>
                        <LabResults
                            unknown={questions.results.subQuestions.ldl.unknown}
                            results={questions.results.subQuestions.ldl.results}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Has the patient ever had any cardiac investigations?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyCardiacInvestigations.referToAttachments}>
                        <p>{questions.anyCardiacInvestigations.value}</p>
                        {questions.anyCardiacInvestigations.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide full details to include the date and results:</Question>
                                <OutputDetails
                                    details={questions.anyCardiacInvestigations.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Is there any history of familial hypercholesterolaemia?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyHistoryOfFamilialHypercholesterolaemia.referToAttachments}>
                        <p>{questions.anyHistoryOfFamilialHypercholesterolaemia.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Has there been a significant change in your patient’s weight since last recorded?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyChangeInWeight.referToAttachments}>
                        <p>{questions.anyChangeInWeight.value}</p>

                        <Question
                            show={questions.anyChangeInWeight.value === 'Yes'}
                            answer={questions.anyChangeInWeight.details}
                        >
                            If yes, please provide full details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Has your patient ever been prescribed or referred for weight loss treatment?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyWeightlossTreatment.referToAttachments}>
                        <p>{questions.anyWeightlossTreatment.value}</p>

                        <Question
                            show={questions.anyWeightlossTreatment.value === 'Yes'}
                            answer={questions.anyWeightlossTreatment.details}
                        >
                            If yes, please provide full details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Has your patient always been compliant with recommended treatments and follow-ups?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.isAlwaysCompliant.referToAttachments}>
                        <p>{questions.isAlwaysCompliant.value}</p>

                        <Question
                            show={questions.isAlwaysCompliant.value === 'No'}
                            answer={questions.isAlwaysCompliant.details}
                        >
                            If no, please provide full details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}